<template>
    <TextTooltip
        :text="tooltipText"
        :canOpen="isTruncated"
        :maxWidth="maxWidth"
    >
        <div
            ref="container"
            :class="{ 'cursor-help': changeMarker && isTruncated }"
            @mouseenter="checkIfTruncated"
            @mouseleave="isTruncated = false"
        >
            <slot />
        </div>
    </TextTooltip>
</template>

<script>
import TextTooltip from '@/Components/Elements/TextTooltip.vue'
export default {
    components: {
        TextTooltip,
    },

    props: {
        changeMarker: {
            type: Boolean,
            default: false,
        },
        maxWidth: {
            type: [String, null],
            default: null,
        },
    },

    data() {
        return {
            isTruncated: false,
            tooltipText: 'The Synergy of Education and Development',
        }
    },
    methods: {
        checkIfTruncated() {
            const truncateElement = this.$refs.container?.querySelector('*')
            if (
                truncateElement &&
                (truncateElement.clientWidth < truncateElement.scrollWidth ||
                    truncateElement.clientHeight < truncateElement.scrollHeight)
            ) {
                // If the tooltipText fails, change this component to recieve the full string instead
                this.tooltipText = truncateElement.innerHTML
                this.isTruncated = true
            }
        },
    },
}
</script>
